export type ApiPayload = {
  code?: unknown
  msg?: unknown
  message?: unknown
  data?: unknown
} | null | undefined

export const SESSION_KICKED_CODE = 4006

export function isSessionKickedCode(code: number | null | undefined): boolean {
  return code === SESSION_KICKED_CODE
}

export function isAuthErrorCode(code: number | null | undefined): boolean {
  return code === 20007 || code === 20009 || code === 4001 || code === 4004 || code === 4005 || isSessionKickedCode(code)
}

export function isApiSuccess(payload: ApiPayload): boolean {
  if (!payload) return false
  return payload.code === 200
}

export function getApiErrorMessage(payload: ApiPayload, fallback = '请求失败'): string {
  if (!payload) return fallback
  const msg = payload.msg ?? payload.message
  if (typeof msg === 'string' && msg.trim()) return msg.trim()
  return fallback
}

export function getApiData<T>(payload: ApiPayload): T | null {
  if (!payload || !isApiSuccess(payload)) return null
  return (payload.data ?? null) as T | null
}

export function extractPageList<T>(pageData: unknown): T[] {
  if (!pageData || typeof pageData !== 'object') return []
  const data = pageData as Record<string, unknown>
  const list = data.list ?? data.records
  return Array.isArray(list) ? (list as T[]) : []
}

export function getAxiosErrorMessage(error: unknown, fallback = '网络异常'): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const response = (error as { response?: { data?: ApiPayload } }).response
    const message = getApiErrorMessage(response?.data)
    if (message && message !== '请求失败') return message
  }
  if (error instanceof Error && error.message) return error.message
  return fallback
}

export function isSessionKickedMessage(message: unknown): boolean {
  if (typeof message !== 'string' || !message) return false
  return /另一地点登录|其他设备登录|在其他设备登录|会话已下线|被迫下线/.test(message)
}

const AUTH_TOKEN_EXPIRED_RE =
  /invalid or expired authentication token|missing authentication token|invalid authentication token|authentication failed|token has expired|unauthorized/i

/** 网关/鉴权拦截器返回的通用 token 失效英文文案 → 登录过期中文提示 */
export function toFriendlyAuthExpiredMessage(message: string): string {
  if (!message) return message
  return AUTH_TOKEN_EXPIRED_RE.test(message) ? '登录已过期，请重新登录' : message
}
